import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const STORAGE_KEY = "billsmax.selectedOrgId";

const readStoredOrgId = () => {
  try {
    const value = Number(window.localStorage.getItem(STORAGE_KEY));
    return value > 0 ? value : null;
  } catch (e) {
    return null;
  }
};

const OrgContext = createContext({ orgId: null, ready: false, selectOrg: () => {}, markReady: () => {} });

/**
 * The organisation the user is working in. The NavBar switcher picks it once the user's orgs have loaded
 * (`ready`); pages wait for `ready` and send `orgId` with every org-scoped API call.
 */
export const OrgProvider = ({ children }) => {
  const [orgId, setOrgId] = useState(readStoredOrgId);
  const [ready, setReady] = useState(false);

  const selectOrg = useCallback((id) => {
    const value = Number(id) > 0 ? Number(id) : null;
    setOrgId(value);
    try {
      if (value) window.localStorage.setItem(STORAGE_KEY, String(value));
      else window.localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }, []);

  const markReady = useCallback(() => setReady(true), []);

  const value = useMemo(() => ({ orgId, ready, selectOrg, markReady }), [orgId, ready, selectOrg, markReady]);
  return <OrgContext.Provider value={value}>{children}</OrgContext.Provider>;
};

export const useOrg = () => useContext(OrgContext);

/** The org a switcher should show: the stored one if the user still belongs to it, otherwise their first org. */
export const pickInitialOrgId = (orgs, storedOrgId) => {
  const ids = (orgs || []).map((o) => Number(o.orgId || o.id)).filter((id) => id > 0);
  if (storedOrgId && ids.includes(storedOrgId)) return storedOrgId;
  return ids.length > 0 ? ids[0] : null;
};
